/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimPipeline } from './ClaimPipeline';
import {
    ClaimPipelineFromJSON,
    ClaimPipelineFromJSONTyped,
    ClaimPipelineToJSON,
    ClaimPipelineToJSONTyped,
} from './ClaimPipeline';

/**
 * List of claim pipelines
 * @export
 * @interface ClaimPipelineListResponse
 */
export interface ClaimPipelineListResponse {
    /**
     * 
     * @type {Array<ClaimPipeline>}
     * @memberof ClaimPipelineListResponse
     */
    pipelines: Array<ClaimPipeline>;
}

/**
 * Check if a given object implements the ClaimPipelineListResponse interface.
 */
export function instanceOfClaimPipelineListResponse(value: object): value is ClaimPipelineListResponse {
    if (!('pipelines' in value) || value['pipelines'] === undefined) return false;
    return true;
}

export function ClaimPipelineListResponseFromJSON(json: any): ClaimPipelineListResponse {
    return ClaimPipelineListResponseFromJSONTyped(json, false);
}

export function ClaimPipelineListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPipelineListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pipelines': ((json['pipelines'] as Array<any>).map(ClaimPipelineFromJSON)),
    };
}

export function ClaimPipelineListResponseToJSON(json: any): ClaimPipelineListResponse {
    return ClaimPipelineListResponseToJSONTyped(json, false);
}

export function ClaimPipelineListResponseToJSONTyped(value?: ClaimPipelineListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pipelines': ((value['pipelines'] as Array<any>).map(ClaimPipelineToJSON)),
    };
}

